/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_DescriptionInputs */

const en_newsletter_description = /** @type {(inputs: Newsletter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay updated on our efforts to advocate for AI safety.`)
};

/**
* | output |
* | --- |
* | "Stay updated on our efforts to advocate for AI safety." |
*
* @param {Newsletter_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_description = /** @type {((inputs?: Newsletter_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_description(inputs)
});